import { Component, OnInit } from '@angular/core';
import { JeevesAddContactModalComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'cult-cult-add-contact-modal',
    templateUrl: './cult-add-contact-modal.component.html',
    styleUrls: ['./cult-add-contact-modal.component.scss'],
    standalone: false
})
export class CultAddContactModalComponent extends JeevesAddContactModalComponent {
  initForm() {
    this.contactForm = this.formBuilder.group({
      name: this.formBuilder.control(''),
      CS1: this.formBuilder.group({
        comkod: '1',
        comnr: this.formBuilder.control('')
      }),
      CS4: this.formBuilder.group({
        comkod: '4',
        comnr: this.formBuilder.control('')
      }),
      CS8: this.formBuilder.group({
        comkod: '3',
        comnr: this.formBuilder.control('')
      })
    });
  }
}